import { Toaster } from "@frends/ui-components/react";

export default Toaster;
